import { computed } from "vue";

/**
 * Natural width/height of a Storyblok CDN asset, parsed from its URL
 * (`…/f/<space>/<W>x<H>/…` — the 6th path segment). Explicit dimensions on
 * `<NuxtImg>` prevent layout shift. Returns undefined width/height (with a
 * dev-only warning) when the URL doesn't follow the CDN shape
 * (external/legacy assets).
 */
const SIZE_SEGMENT = /^\d+x\d+$/;

export const useStoryblokAssetDimensions = (
	filename: () => string | undefined
) =>
	computed<{ width?: string; height?: string }>(() => {
		const src = filename();
		const segment = src?.split("/")?.[5];
		if (!segment || !SIZE_SEGMENT.test(segment)) {
			if (import.meta.dev && src) {
				console.warn(
					`[useStoryblokAssetDimensions] asset URL has no WxH segment — the image renders without explicit dimensions (CLS risk): ${src}`
				);
			}
			return { width: undefined, height: undefined };
		}
		const [width, height] = segment.split("x");
		return { width, height };
	});
